//#region src/schema/localization/locales/en.ts
var e = {
	schema: {
		noAllowedValues: "No values satisfy this enum constraint.",
		example: "Example",
		examples: "Examples",
		default: "Default",
		schema: "Schema",
		emptyObject: "Empty object",
		showAdditionalProperties: "Show additional properties",
		showOneMoreProperty: "Show 1 more property",
		showMoreProperties: "Show {count} more properties",
		forName: "for {name}",
		showSchemaDetails: "Show Schema Details",
		oneOf: "One of",
		anyOf: "Any of",
		allOf: "All of",
		not: "Not",
		unknownType: "unknown type",
		propertyCount: "Properties: {count}",
		headerCount: "Headers: {count}",
		recursiveReference: "Recursive reference to {name}",
		recursive: "recursive",
		additionalProperties: "additional properties",
		const: "const",
		deprecated: "deprecated",
		discriminator: "Discriminator",
		enum: "enum",
		format: "Format",
		greaterThan: "greater than",
		keys: "keys",
		lessThan: "less than",
		max: "max",
		min: "min",
		maxLength: "max length",
		minLength: "min length",
		multipleOf: "multiple of",
		nullable: "nullable",
		propertyNames: "property names",
		pattern: "Pattern",
		copyPattern: "Copy pattern",
		readOnly: "read-only",
		required: "required",
		hideValues: "Hide values",
		showAllValues: "Show all values",
		type: "Type",
		unique: "unique",
		values: "values",
		writeOnly: "write-only"
	},
	common: {
		copyDefault: "Copy default value",
		copyExample: "Copy example value"
	},
	actions: { copyLinkTo: "Copy link to {name}" }
};
//#endregion
export { e as en };

//# sourceMappingURL=en.js.map